import { get } from 'global/lib/lodash';
import React from 'react';
import { useSelector } from 'react-redux';
import { VendorList } from '../../admin/vendors';

export default (props) => {
  const { vendors } = props;
  const filter = useSelector((state) => get(state, 'filter.users.manage'));

  const clientId = get(filter, 'client_id', 0);
  const show = clientId !== 0;

  const getVendor = () => {
    const vendor = vendors.data.find((v) => v.id === clientId);
    return vendor && [vendor];
  };

  const vend = getVendor();

  return !show ? null : (
    <>
      <VendorList data={vend} canEdit={false} hideBorders namePrefix={'Client: '} />
    </>
  );
};
